"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeSigners = exports.formatSender = exports.deserializeWitnesses = exports.deserializeAttributes = exports.deserializeValidUntilBlock = exports.deserializeFee = exports.deserializeScript = exports.deserializeNonce = exports.deserializeVersion = void 0;
const u_1 = require("../../u");
const components_1 = require("../components");
const wallet_1 = require("../../wallet");
const logging_1 = __importDefault(require("../../logging"));
const log = (0, logging_1.default)("tx");
function deserializeVersion(ss, tx = {}) {
    const byte = ss.read();
    const version = parseInt(byte, 16);
    if (version !== 0) {
        log.error(`Transaction version should be 0 not ${version}`);
    }
    return Object.assign(tx, { version });
}
exports.deserializeVersion = deserializeVersion;
function deserializeNonce(ss, tx = {}) {
    const nonce = parseInt((0, u_1.reverseHex)(ss.read(4)), 16);
    return Object.assign(tx, { nonce });
}
exports.deserializeNonce = deserializeNonce;
function deserializeScript(ss, tx = {}) {
    const script = ss.readVarBytes();
    if (script.length === 0) {
        log.error("Script should not be vacant.");
    }
    return Object.assign(tx, { script });
}
exports.deserializeScript = deserializeScript;
function deserializeFee(ss, tx = {}) {
    const systemFee = u_1.BigInteger.fromTwos(ss.read(8), true);
    const networkFee = u_1.BigInteger.fromTwos(ss.read(8), true);
    return Object.assign(tx, { systemFee, networkFee });
}
exports.deserializeFee = deserializeFee;
function deserializeValidUntilBlock(ss, tx) {
    const validUntilBlock = parseInt((0, u_1.reverseHex)(ss.read(4)), 16);
    return Object.assign(tx, { validUntilBlock });
}
exports.deserializeValidUntilBlock = deserializeValidUntilBlock;
function deserializeAttributes(ss, tx) {
    const attributes = (0, u_1.deserializeArrayOf)(components_1.TransactionAttribute.fromStream, ss).map((i) => i.export());
    return Object.assign(tx, { attributes });
}
exports.deserializeAttributes = deserializeAttributes;
function deserializeWitnesses(ss, tx) {
    const witnesses = (0, u_1.deserializeArrayOf)(components_1.Witness.fromStream, ss).map((i) => i.export());
    return Object.assign(tx, { witnesses });
}
exports.deserializeWitnesses = deserializeWitnesses;
function formatSender(sender) {
    if (!sender) {
        return "";
    }
    if (sender.length === 42 && sender.startsWith("0x")) {
        const hex = sender.slice(2);
        (0, u_1.ensureHex)(hex);
        return hex;
    }
    else if (sender.length === 40) {
        (0, u_1.ensureHex)(sender);
        return sender;
    }
    else if (sender.length === 34) {
        return (0, wallet_1.getScriptHashFromAddress)(sender);
    }
    else {
        throw new Error(`Sender format error: ${sender}`);
    }
}
exports.formatSender = formatSender;
function deserializeSigners(ss, tx) {
    const signers = (0, u_1.deserializeArrayOf)(components_1.Signer.deserialize, ss);
    if (!signers.every((s) => signers.indexOf(s) === signers.lastIndexOf(s))) {
        log.warn("Signer should not duplicate.");
    }
    return Object.assign(tx, { signers });
}
exports.deserializeSigners = deserializeSigners;
